import AthleteTrivia from "../components/AthleteTrivia";

const choices = [
  { number: 'A', answer: 'Georgia', correct: true },
  { number: 'B', answer: 'Mississippi', correct: false },
  { number: 'C', answer: 'Alabama', correct: false },
  { number: 'D', answer: 'California', correct: false }
]

const question = 'In what state was Will born?'
const message = 'Will was born in Hampton, GA and played High School football at Dutchtown High School.'


const TriviaWill = () => {
  return (
    <AthleteTrivia 
      athlete_name={'Will'}
      closet_path={'/will-closet'}
      video_path={'will/will_quiz.mp4'}
      question_id={3}
      choices={choices}
      question={question}
      message={message}
    />
  )
}
export default TriviaWill;
